import { Button } from '../../../../components';
import { PaymentCard, PaymentCardProps } from './PaymentCard';

type CardViewProps = PaymentCardProps & {
    onDeleteClick?: () => void;
    onSetPreferredClick?: () => void;
};

export const CardView: React.FC<CardViewProps> = ({
    onDeleteClick,
    onSetPreferredClick,
    ...props
}) => {
    return (
        <div data-testid="card-view" className="flex flex-col gap-4">
            <div data-testid="card-view-header" className="flex w-full justify-between">
                {props.isPreferred ? (
                    <div data-testid="preferred-card-label" className="text-primary text-body-medium">
                        Preferred Card
                    </div>
                ) : (
                    <Button
                        data-testid="make-preferred-button"
                        variant="link"
                        onClick={onSetPreferredClick}
                    >
                        Make Preferred
                    </Button>
                )}
                <Button
                    data-testid="delete-button"
                    className="ml-auto"
                    variant="link"
                    onClick={onDeleteClick}
                >
                    Delete
                </Button>
            </div>
            <PaymentCard {...props} />
        </div>
    );
};
